var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25995",
    "data-name": "Group 25995",
    transform: "translate(-1341.5 -11974.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1612",
    "data-name": "Ellipse 1612",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1341.5 11974.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh-page-option",
    transform: "translate(1348.766 11981.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25921",
    "data-name": "Group 25921",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M13.4.461a.346.346,0,0,0-.5,0l-.717.711A4.27,4.27,0,0,0,10.838.309,4.161,4.161,0,0,0,9.272,0,4.071,4.071,0,0,0,6.626.921a4.3,4.3,0,0,0-1.489,2.4v.039a.179.179,0,0,0,.176.176h1.1A.165.165,0,0,0,6.576,3.4a6.666,6.666,0,0,1,.292-.645,2.812,2.812,0,0,1,2.4-1.345A2.74,2.74,0,0,1,11.2,2.17l-.761.761a.353.353,0,0,0,.248.6h2.47a.358.358,0,0,0,.353-.353V.709A.339.339,0,0,0,13.4.461Z",
    transform: "translate(-5.038 -0.003)",
    fill: "#172b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M8.154,255.8H7.1a.165.165,0,0,0-.165.127,6.672,6.672,0,0,1-.292.645,2.812,2.812,0,0,1-2.4,1.345,2.752,2.752,0,0,1-1.031-.2,2.848,2.848,0,0,1-.888-.563l.755-.755a.353.353,0,0,0-.248-.6H.353a.339.339,0,0,0-.248.1.339.339,0,0,0-.1.248v2.47a.339.339,0,0,0,.1.248.34.34,0,0,0,.248.1.34.34,0,0,0,.248-.1l.711-.711a4.209,4.209,0,0,0,1.343.866,4.128,4.128,0,0,0,1.558.3,4.042,4.042,0,0,0,2.635-.918,4.285,4.285,0,0,0,1.478-2.4.1.1,0,0,0,.005-.039.179.179,0,0,0-.177-.176Z",
    transform: "translate(0 -250.861)",
    fill: "#172b37"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.3a15e0f038016d98a429e06f139db061.svg";
export { ForwardRef as ReactComponent };